import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';
const TOKEN_KEY = 'catalogoAdminToken';

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  if (method !== 'get') {
    const token = getAdminToken();
    if (token) {
      config.headers['X-Admin-Token'] = token;
    }
  }
  return config;
});

export const verifyAdmin = async (token) => {
  const response = await api.post('/auth/verify', { token });
  return response.data;
};

export const getApps = async () => {
  const response = await api.get('/apps');
  return response.data;
};

export const getApp = async (id) => {
  const response = await api.get(`/apps/${id}`);
  return response.data;
};

export const createApp = async (appData) => {
  const response = await api.post('/apps', appData);
  return response.data;
};

export const updateApp = async (id, appData) => {
  const response = await api.put(`/apps/${id}`, appData);
  return response.data;
};

export const deleteApp = async (id) => {
  const response = await api.delete(`/apps/${id}`);
  return response.data;
};

export const updateAppCosts = async (id, costs) => {
  const response = await api.put(`/apps/${id}/costs`, costs);
  return response.data;
};

export const reorderApps = async (orderedIds) => {
  const response = await api.put('/apps/order', { orderedIds });
  return response.data;
};

export const setAppVisibility = async (id, visible) => {
  const response = await api.put(`/apps/${id}`, { visibleInCatalog: visible });
  return response.data;
};

// Categories API
export const getCategories = async () => {
  const response = await api.get('/categories');
  return response.data;
};

export const createCategory = async (categoryData) => {
  const response = await api.post('/categories', categoryData);
  return response.data;
};

export const updateCategory = async (id, categoryData) => {
  const response = await api.put(`/categories/${id}`, categoryData);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await api.delete(`/categories/${id}`);
  return response.data;
};

export default api;
